import { LockClosedIcon } from "@heroicons/react/24/outline";
import type { FinanceCapability } from "../../finance/types";

interface FinanceLockedProps {
  capability: FinanceCapability;
}

export default function FinanceLocked({ capability }: FinanceLockedProps) {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-8 sm:px-8">
      <section className="mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-50">
          <LockClosedIcon className="h-6 w-6 text-emerald-700" aria-hidden />
        </div>
        <h1 className="mt-5 text-2xl font-semibold text-slate-900">
          Unlock WipSync Finance
        </h1>
        <p className="mt-3 text-slate-600">
          Upgrade to WipSync Operations to understand sales, gross profit,
          production costs, supplier spending, customer profitability, and
          current inventory value.
        </p>
        <p className="mt-5 text-sm text-slate-500">
          Current plan: <span className="font-medium capitalize">{capability.plan}</span>
        </p>
      </section>
    </main>
  );
}
